@import '../../styles/variables.scss';
@import '../../styles/mixins.scss';

.favourites-icon {
  margin-bottom: 1.5rem;
}
